import { Component } from 'react';
import { connect } from 'react-redux';

import Button from 'components/atoms/Button';
import DropList from 'components/atoms/DropList';
import Form from 'components/atoms/Form';
import FormGroup from 'components/atoms/FormGroup';
import Icon from 'components/atoms/Icon';
import Label from 'components/atoms/Label';
import LoaderSpinner from 'components/atoms/LoaderSpinner';
import { ADMIN_TAG_TYPES } from 'data/static';
import { bindActionCreators, Dispatch } from 'redux';
import { tagOrder, tagRecords } from 'services/tags';
import { SetErrorHandlerAction, setErrorHandlerAction } from 'store/actions/errorsActions';
import { PortType, RootState } from 'types';
import { ActionsType } from 'types/system';
import { renderError, setKey } from 'utils/formHandlers';
import { translate } from 'utils/translate';

interface OrderTagModelProps {
    //unused props
    children?: string | JSX.Element | JSX.Element[];

    //unused props
    language: string;

    id?: string;

    //unused props
    data: any;

    actions: ActionsType | undefined;
    port: PortType;
    setErrorHandlerAction: SetErrorHandlerAction;
}

interface OrderTagModelState {
    errors: any;

    //unused state
    data: any | null;

    loading: boolean;
    tag: {
        type: string;
    };
    tags: any[];
    saving: boolean;
    items: any[];
    draggingIndex: number;
}

class OrderTagModel extends Component<OrderTagModelProps, OrderTagModelState> {
    constructor(props: OrderTagModelProps) {
        super(props);
        this.state = {
            data: null,
            loading: true,
            errors: {},
            saving: false,
            tag: {
                type: '',
            },
            tags: [],
            items: [],
            draggingIndex: 0,
        };
    }

    componentDidMount() {
        tagRecords(this.props.port.id, {
            page: 1,
            limit: 100000,
        })
            .then((res) => {
                this.setState({
                    tags: res.items,
                    loading: false,
                });
            })
            .catch((errors) => {
                this.props.setErrorHandlerAction(errors);
            });
    }

    handleChange = (name: string, value: unknown) => {
        const { tag, errors } = this.state;
        setKey(tag, name, value);
        setKey(errors, name, null);

        this.setState({
            tag,
            errors,
            items: this.state.tags
                .filter((x) => {
                    return x.type === value;
                })
                .filter((x) => {
                    return x.type === this.state.tag.type;
                })
                .sort((a, b) => {
                    if (a.order < b.order) {
                        return -1;
                    }
                    if (a.order > b.order) {
                        return 1;
                    }
                    return 0;
                }),
        });
    };

    handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e?.preventDefault();
        this.setState({ saving: true }, () => {
            tagOrder(this.props.port.id, {
                tags: this.state.items.map((x) => {
                    return { id: x.id, order: x.order, label: x.label };
                }),
            })
                .then(() => {
                    this.props.actions?.onConfirm();
                    this.props.actions?.onCancel();
                })
                .catch((errors) => {
                    this.props.setErrorHandlerAction(errors);
                });
        });
    };

    handleFormCancel = () => {
        this.props.actions?.onCancel();
    };

    handleDragStart = (index) => {
        this.setState({ draggingIndex: index });
    };

    handleDragOver = (index) => {
        const { draggingIndex, items } = this.state;
        const draggedItem = items[draggingIndex];

        // Create a copy of the items array
        const newItems = [...items];
        newItems.splice(draggingIndex, 1); // Remove dragged item
        newItems.splice(index, 0, draggedItem); // Insert dragged item at new position

        this.setState({
            items: newItems.map((x, i) => {
                x.order = i + 1;
                return x;
            }),
            draggingIndex: index,
        });
    };

    handleFormReset = () => {
        this.setState({
            items: this.state.tags
                .filter((x) => {
                    return x.type === this.state.tag.type;
                })
                .sort((a, b) => {
                    if (a.label.toLowerCase() < b.label.toLowerCase()) {
                        return -1;
                    }
                    if (a.label.toLowerCase() > b.label.toLowerCase()) {
                        return 1;
                    }
                    return 0;
                })
                .map((x, i) => {
                    x.order = i + 1;
                    return x;
                }),
        });
    };

    render() {
        return (
            <>
                <Form onSubmit={this.handleFormSubmit} className="bg-white shadow p-4 w-full rounded">
                    <div id={`Drag-${this.props.id}`} className="flex justify-between mb-2 no-select ">
                        <div className="text-lg leading-6 font-bold">{translate('Tag sorter')} </div>
                        <div
                            onTouchEnd={this.handleFormCancel}
                            onClick={this.handleFormCancel}
                            className="cursor-pointer"
                        >
                            <Icon>
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M18 6l-12 12" />
                                <path d="M6 6l12 12" />
                            </Icon>
                        </div>
                    </div>

                    <div className="mt-4 mb-4  relative rounded-md ">
                        {!this.state.tag.type ? (
                            <>
                                {this.state.loading ? (
                                    <div className="bg-white  text-center flex items-center justify-center  ">
                                        <LoaderSpinner variant="button"></LoaderSpinner>
                                    </div>
                                ) : (
                                    <>
                                        <FormGroup comments={renderError(this.state.errors?.['type'])} required={false}>
                                            <Label>{translate('Type')}</Label>
                                            <DropList  capitalize
                                                name="type"
                                                id="type"
                                                value={this.state.tag?.type}
                                                options={ADMIN_TAG_TYPES}
                                                onChange={this.handleChange}
                                            ></DropList>
                                        </FormGroup>
                                        <p className="mt-1 mb-3">{translate('Select tag type first to order')}</p>
                                    </>
                                )}
                            </>
                        ) : (
                            <>
                                <FormGroup comments={renderError(this.state.errors?.['type'])} required={false}>
                                    <Label>{translate('Type')}</Label>
                                    <DropList  capitalize
                                        name="type"
                                        id="type"
                                        value={this.state.tag?.type}
                                        options={ADMIN_TAG_TYPES}
                                        onChange={this.handleChange}
                                    ></DropList>
                                </FormGroup>

                                <p className="mt-1 mb-3">
                                    {translate('found tags', {
                                        count: this.state.items.length,
                                        type: this.state.tag.type,
                                    })}
                                </p>
                                <ul style={{ maxHeight: '70vh' }} className="flex flex-col flex-wrap gap-1 ">
                                    {this.state.items.map((item, index) => (
                                        <li
                                            key={index}
                                            draggable
                                            className="border capitalize w-28 border-gray-300 rounded-sm  p-1 cursor-pointer relative"
                                            onDragStart={() => this.handleDragStart(index)}
                                            onDragOver={() => this.handleDragOver(index)}
                                        >
                                            <span
                                                title={item.label}
                                                className="capitalize font-bold text-black pl-1 pt-2 block text-sm truncate"
                                            >
                                                {item.label}
                                            </span>
                                            <span className=" block text-xs absolute top-0 right-1">{item.total}</span>
                                        </li>
                                    ))}
                                </ul>
                            </>
                        )}
                    </div>

                    <div className="flex justify-end">
                        <div className="mt-5 flex gap-3">
                            <Button
                                type="button"
                                className="px-4 py-2 font-bold border border-gray-400"
                                onClick={this.handleFormCancel}
                            >
                                {translate('Cancel')}
                            </Button>
                            <Button
                                type="button"
                                className="px-4 py-2 font-bold border border-gray-400"
                                onClick={this.handleFormReset}
                            >
                                {translate('Reset order')}
                            </Button>
                            <Button
                                disabled={this.state.loading}
                                loading={this.state.saving}
                                type="submit"
                                className="px-4 py-2 bg-primary-submit rounded-md text-white"
                            >
                                {translate('Save')}
                            </Button>
                        </div>
                    </div>
                </Form>
            </>
        );
    }
}
const mapStateToProps = (state: RootState) => ({
    port: state.port.port,
    language: state.user.user.language,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    setErrorHandlerAction: bindActionCreators(setErrorHandlerAction, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(OrderTagModel);
